import React from 'react';

const ContactsIndex = () => {
    return <div>Contacts</div>;
};

export default ContactsIndex;
